var r=function(r,n){return n};export{r as CustomThemeProperty};
//# sourceMappingURL=types.js.map
